
import Vue from "vue";
import Component from "vue-class-component";

@Component({})
export default class AlertGuidelineModal extends Vue {
  year = new Date().getFullYear();

  public onModalClosed = (): void => {
    this.$router.push("/participant/guidelines");
  };
}
